import {ClsPeticionPresupuestos} from './cls-pr-generico';
import {ClsErrores} from '../cls-errores';
import {
  ClsCalculoDetalleExpXConcepto, ClsCalculoDetalleExpXConceptoProyecto,
  ClsCalculoGuardarCatalogo,
  ClsCalculoGuardarPartidas, ClsCatalogoCalculo,
  ClsWBSRenglon
} from '../cls-calculo';

export class ClsPeticionGuardarCatalogo extends ClsPeticionPresupuestos {
  Catalogos: ClsCalculoGuardarCatalogo[];
}

export class ClsPeticionGuardarPartidas extends ClsPeticionPresupuestos {
  Partidas: ClsCalculoGuardarPartidas[];
}

export class ClsPeticionGuardarExpXConceptos extends ClsPeticionPresupuestos {
  ExpinsXconcepto: ClsPeticionExpinsXconcepto[];
}

export class ClsPeticionExpinsXconcepto {
  IdCodigoMatriz: bigint;
  JsonExpinsXconcepto: ClsCalculoDetalleExpXConcepto[];
  Errores?: ClsErrores;
}

export class ClsPeticionExpinsXconceptoXProyecto {
  ExpinsXconcepto: ClsCalculoDetalleExpXConceptoProyecto[];
  Errores?: ClsErrores;
}

export class ClsPeticionPartidaWBS extends ClsPeticionPresupuestos {
  LsPartidaWBS: ClsWBSRenglon[];
}

export class ClsPeticionTasaInteresMonedas extends ClsPeticionPresupuestos {
  TasaInteresMoneda1: number;
  TasaInteresMoneda2: number;
}

export class ClsPeticionFechaMonedas extends ClsPeticionPresupuestos {
  FechaMoneda1: any;
  FechaMoneda2: any;
}

export class ClsPeticionCatalogoDetalleCostosRegistraActualiza2021  extends ClsPeticionPresupuestos {
  Catalogo: ClsCatalogoCalculo[];
}
